var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"pa-2",attrs:{"color":"#42A5F5"}},[_c('canvas',{ref:"chart1",attrs:{"id":"chart1","height":"500"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }